import { isMounted as I, urlUtils as M } from "@sunrise/shared";
import { Components as l } from "@sunrise/types";
import { computed as p } from "vue";
const r = "{{URL}}", E = "{{TITLE}}", m = "{{DESCRIPTION}}", R = "{{DELIMITER}}", A = `https://www.facebook.com/sharer/sharer.php?u=${r}`, L = `https://api.whatsapp.com/send/?text=${r}&type=custom_url&app_absent=0`, T = `mailto:?subject=${E}&body=${m}${R}${r}`;
function f(e, t, n, o, d) {
  const c = i(e, t.value, d.value), a = encodeURIComponent(c), s = encodeURIComponent(n.value), u = encodeURIComponent((o == null ? void 0 : o.value) || "");
  return e === l.CsShareModal.ShareTypes.EMAIL ? T.replace(E, s).replace(m, u).replace(R, u ? "%0D%0A" : "").replace(r, a) : e === l.CsShareModal.ShareTypes.FACEBOOK ? A.replace(r, a) : e === l.CsShareModal.ShareTypes.WHATSAPP ? L.replace(r, a) : encodeURI(c);
}
function i(e, t, n) {
  const o = n == null ? void 0 : n[e];
  return o && M.buildUrl(t, { ecid: o }) || t;
}
function P(e, t, n, o) {
  const d = I(), c = p(() => !e.value && !d.value ? "" : e.value || window.location.href);
  return { computedLinks: p(() => Object.values(l.CsShareModal.ShareTypes).reduce((s, u) => (s[u] = f(u, c, t, n, o), s), {})) };
}
export {
  P as useLinkBuilder
};
